import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "app-modal-resumo-lote-gerado",
  templateUrl: "./modal-resumo-lote-gerado.component.html",
  styleUrls: ["./modal-resumo-lote-gerado.component.scss"],
})
export class ModalResumoLoteGeradoComponent implements OnInit {
  isLoading = true;
  textoCancelar = "Cancelar";
  textoOk = "Fechar";
  texto;

  titulo = "Lotes gerados para processamento";

  public displayedColumns: string[] = ["descricao", "totalFrete"];
  public gridResumoLoteGerado: MatTableDataSource<any> =
    new MatTableDataSource<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<ModalResumoLoteGeradoComponent>
  ) {
    this.gridResumoLoteGerado.data = data.gridLote.listaLotes;
  }

  ngOnInit() {
    this.isLoading = false;
  }

  close() {
    this.dialog.close(1);
  }
}
